import { queryOptions, useQuery } from "@tanstack/react-query";
import { get } from "lodash";
import { apiBase } from "../utils/apiBase";

export const aggregatesQuery = queryOptions({
  queryKey: ["aggregates"],
  queryFn: () =>
    apiBase.get("aggregates").then((res) => get(res, "data.aggregates", {})),
  staleTime: 60 * 60 * 1000, // 1h
  gcTime: Infinity,
  refetchOnWindowFocus: true,
  meta: { errorMessage: "Failed to load aggregates." },
});

export const useAggregates = () => useQuery(aggregatesQuery);
